module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Administración del dinero",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Administración"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("del ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" dinero")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Administración del dinero',
      "videoEmbed": "ADMINISTRACIONDINERO03AdministracionDelDinero.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box"
  }, [_vm._v("Administrar el dinero no significa crear un presupuesto estricto y renunciar a los gustos espontáneos. Significa tomar decisiones conscientes al momento de gastar el dinero, lo que puede ayudarle a reducir deudas y a acumular ahorros para usarlos en el futuro y cumplir las "), _c('strong', [_vm._v("metas.")]), _vm._v(" "), _c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "audios": [
        'Administracion1.mp3'
      ]
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 230,
      "imaSrc": "contenido/personaje_1",
      "imaAlt": "Mujer explicando el concepto"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53dadf1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-03.vue
// module id = 973
// module chunks = 1